import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sdvx');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const YOUTUBE_SEARCH_URL = 'https://www.youtube.com/results';
const THEME_STORAGE_KEY = 'taigo_theme_mode';
const PRIVATE_ACCOUNT_ID = 'nnnewnxxapseyldhonxpghbqkjykgduh';

type ThemeMode = 'dark' | 'light';
type SortMode = 'default' | 'chain' | 'bpm' | 'version' | 'title';

@Component({
    selector: 'wiz-page-sdvx',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sdvx/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.sdvx-root {
  min-height: 100vh;
  background: #f4f4f5;
  color: #18181b;
}

.sdvx-wrap {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: 0 10px;
}

.sdvx-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d4d4d8;
  background: rgba(250, 250, 250, 0.96);
}

.sdvx-header-inner {
  padding-top: 6px;
  padding-bottom: 7px;
}

.sdvx-title-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.sdvx-title-block {
  min-width: 0;
}

.sdvx-title-block h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.sdvx-nav {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.sdvx-theme-toggle,
.sdvx-nav-action,
.sdvx-tier-tab,
.sdvx-sort-toggle,
.sdvx-control,
.sdvx-clear {
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.sdvx-theme-toggle {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: border-color 0.18s ease, color 0.18s ease;
}

.sdvx-theme-toggle:hover,
.sdvx-nav-action:hover,
.sdvx-sort-toggle:hover {
  border-color: #155e75;
  color: #0e7490;
}

.sdvx-theme-toggle svg {
  width: 15px;
  height: 15px;
}

.sdvx-nav-action {
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
}

.sdvx-export-open {
  gap: 4px;
}

.sdvx-export-open svg,
.sdvx-data-refresh svg {
  width: 13px;
  height: 13px;
}

.sdvx-data-refresh {
  gap: 4px;
}

.sdvx-data-refresh:disabled {
  color: #a1a1aa;
  cursor: wait;
}

.sdvx-export-open:disabled {
  color: #a1a1aa;
  cursor: wait;
}

.sdvx-export-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid #d4d4d8;
  border-top-color: #155e75;
  border-radius: 999px;
  animation: sdvx-spin 0.8s linear infinite;
}

.sdvx-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  margin-top: 6px;
}

.sdvx-tier-tabs {
  display: flex;
  min-width: 0;
  gap: 4px;
  overflow-x: auto;
  padding-bottom: 1px;
}

.sdvx-tier-tab,
.sdvx-sort-toggle,
.sdvx-control,
.sdvx-clear {
  height: 30px;
  font-size: 12px;
  line-height: 1;
}

.sdvx-tier-tab {
  min-width: 42px;
  flex: 0 0 auto;
  padding: 0 10px;
  font-weight: 600;
}

.sdvx-tier-tab.is-active {
  border-width: 2px;
  color: #18181b;
}

.sdvx-filter-row {
  display: grid;
  grid-template-columns: 126px 92px 116px 132px 168px 58px;
  gap: 6px;
}

.sdvx-sort-toggle,
.sdvx-control,
.sdvx-clear {
  min-width: 0;
  padding: 0 8px;
}

.sdvx-sort-toggle {
  overflow: hidden;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdvx-control {
  color: #18181b;
}

.sdvx-search {
  width: 100%;
}

.sdvx-clear {
  font-weight: 600;
}

.sdvx-clear:disabled {
  color: #a1a1aa;
  cursor: not-allowed;
}

.sdvx-search-summary {
  grid-column: 1/-1;
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
}

.sdvx-search-summary span {
  display: inline-flex;
  height: 18px;
  align-items: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  padding: 0 7px;
  white-space: nowrap;
}

.sdvx-scope-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 6px;
  border-top: 1px solid #e4e4e7;
  padding-top: 6px;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.sdvx-data-age {
  color: #71717a;
}

.sdvx-data-status {
  color: #0e7490;
}

.sdvx-data-status.is-error {
  color: #b91c1c;
}

.sdvx-scroll {
  scrollbar-width: thin;
  scrollbar-color: #a1a1aa transparent;
}

.sdvx-scroll::-webkit-scrollbar {
  height: 5px;
}

.sdvx-scroll::-webkit-scrollbar-thumb {
  background: #a1a1aa;
}

.sdvx-main {
  padding-top: 7px;
  padding-bottom: 24px;
}

.sdvx-loading,
.sdvx-empty {
  display: grid;
  min-height: 220px;
  place-items: center;
  color: #71717a;
  font-size: 13px;
  font-weight: 600;
}

.sdvx-loading {
  align-content: center;
}

.sdvx-loading p,
.sdvx-empty p {
  margin: 8px 0 0;
}

.sdvx-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e4e4e7;
  border-top-color: #71717a;
  border-radius: 999px;
  animation: sdvx-spin 0.8s linear infinite;
}

.sdvx-weekly-panel {
  margin-bottom: 7px;
  border: 1px solid #a1a1aa;
  background: #ffffff;
}

.sdvx-weekly-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #d4d4d8;
  padding: 8px 9px;
}

.sdvx-weekly-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.sdvx-weekly-mark {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #155e75;
  background: #164e63;
  color: #ecfeff;
  font-size: 12px;
  font-weight: 600;
}

.sdvx-weekly-title h2 {
  margin: 0;
  color: #18181b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.sdvx-weekly-title p {
  margin: 2px 0 0;
  overflow: hidden;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdvx-weekly-count {
  flex: 0 0 auto;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
}

.sdvx-weekly-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.sdvx-weekly-card {
  min-width: 0;
  overflow: hidden;
  border-right: 1px solid #d4d4d8;
  border-bottom: 1px solid #e4e4e7;
  padding: 7px 8px;
}

.sdvx-weekly-card-top {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
}

.sdvx-weekly-song {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 4px;
}

.sdvx-weekly-song-title {
  min-width: 0;
  overflow: hidden;
  color: #18181b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdvx-weekly-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 2px;
}

.sdvx-weekly-source {
  display: inline-flex;
  height: 17px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
  padding: 0 5px;
  font-size: 9px;
  font-weight: 600;
}

.sdvx-weekly-source:hover {
  border-color: #155e75;
  color: #0e7490;
}

.sdvx-weekly-meta {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  overflow: hidden;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}

.sdvx-weekly-tier {
  display: inline-flex;
  height: 17px;
  flex: 0 0 auto;
  align-items: center;
  border-left: 3px solid #a1a1aa;
  background: #f4f4f5;
  color: #27272a;
  padding: 0 5px;
  font-size: 10px;
  font-weight: 500;
}

.sdvx-weekly-reason {
  margin: 6px 0 0;
  overflow: hidden;
  color: #52525b;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdvx-table {
  border-top: 1px solid #a1a1aa;
  border-left: 1px solid #a1a1aa;
  background: #ffffff;
}

.sdvx-tier-row {
  display: grid;
  grid-template-columns: 142px minmax(0, 1fr);
  border-bottom: 1px solid #a1a1aa;
}

.sdvx-tier-label {
  display: flex;
  min-height: 62px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-right: 1px solid #a1a1aa;
  padding: 6px;
  text-align: center;
}

.sdvx-tier-name {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.15;
}

.sdvx-tier-count {
  min-width: 24px;
  color: currentColor;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.72;
}

.sdvx-song-grid {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.sdvx-song-cell {
  position: relative;
  min-width: 0;
  min-height: 62px;
  overflow: hidden;
  border-right: 1px solid #d4d4d8;
  border-bottom: 1px solid #e4e4e7;
  background: #ffffff;
  padding: 5px 6px;
}

.sdvx-song-top {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
}

.sdvx-title-wrap {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 4px;
}

.sdvx-difficulty {
  flex: 0 0 auto;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
}

.sdvx-song-title {
  min-width: 0;
  overflow: hidden;
  color: #18181b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdvx-song-title:focus-visible {
  outline: 1px solid #0891b2;
  outline-offset: 1px;
}

.sdvx-top-action {
  display: inline-flex;
  width: auto;
  height: 17px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.sdvx-youtube,
.sdvx-song-source {
  display: inline-flex;
  width: 28px;
  height: 17px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
}

.sdvx-youtube {
  color: #a1a1aa;
}

.sdvx-youtube:hover {
  color: #dc2626;
}

.sdvx-youtube svg {
  width: 13px;
  height: 13px;
}

.sdvx-song-source {
  position: absolute;
  right: 6px;
  bottom: 5px;
  z-index: 2;
  border: 1px solid #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
}

.sdvx-song-source:hover {
  border-color: #155e75;
  color: #0e7490;
}

.sdvx-song-meta,
.sdvx-song-detail {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
  overflow: hidden;
  padding-right: 30px;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}

.sdvx-song-meta span,
.sdvx-song-detail span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.sdvx-song-detail {
  color: #52525b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 9px;
}

.sdvx-title-tooltip {
  position: fixed;
  z-index: 80;
  max-width: min(420px, 100vw - 16px);
  border: 1px solid #27272a;
  border-radius: 4px;
  background: #18181b;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.26);
  color: #f4f4f5;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, -100%);
  white-space: normal;
}

.sdvx-title-tooltip.is-below {
  transform: translate(-50%, 0);
}

.sdvx-root.theme-dark {
  background: #09090b;
  color: #f4f4f5;
}

.sdvx-root.theme-dark .sdvx-header {
  border-bottom-color: #27272a;
  background: rgba(24, 24, 27, 0.96);
}

.sdvx-root.theme-dark .sdvx-theme-toggle,
.sdvx-root.theme-dark .sdvx-nav-action,
.sdvx-root.theme-dark .sdvx-tier-tab,
.sdvx-root.theme-dark .sdvx-sort-toggle,
.sdvx-root.theme-dark .sdvx-control,
.sdvx-root.theme-dark .sdvx-clear,
.sdvx-root.theme-dark .sdvx-song-source {
  border-color: #3f3f46;
  background: #18181b;
  color: #d4d4d8;
}

.sdvx-root.theme-dark .sdvx-weekly-source {
  border-color: #3f3f46;
  background: #27272a;
  color: #d4d4d8;
}

.sdvx-root.theme-dark .sdvx-theme-toggle:hover,
.sdvx-root.theme-dark .sdvx-nav-action:hover,
.sdvx-root.theme-dark .sdvx-sort-toggle:hover,
.sdvx-root.theme-dark .sdvx-song-source:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.sdvx-root.theme-dark .sdvx-export-spinner {
  border-color: #3f3f46;
  border-top-color: #67e8f9;
}

.sdvx-root.theme-dark .sdvx-tier-tab,
.sdvx-root.theme-dark .sdvx-clear {
  color: #a1a1aa;
}

.sdvx-root.theme-dark .sdvx-tier-tab.is-active,
.sdvx-root.theme-dark .sdvx-clear:hover {
  color: #f4f4f5;
}

.sdvx-root.theme-dark .sdvx-table,
.sdvx-root.theme-dark .sdvx-song-cell,
.sdvx-root.theme-dark .sdvx-weekly-panel,
.sdvx-root.theme-dark .sdvx-weekly-card {
  background: #18181b;
}

.sdvx-root.theme-dark .sdvx-table,
.sdvx-root.theme-dark .sdvx-tier-row,
.sdvx-root.theme-dark .sdvx-tier-label {
  border-color: #52525b;
}

.sdvx-root.theme-dark .sdvx-weekly-panel,
.sdvx-root.theme-dark .sdvx-weekly-head {
  border-color: #52525b;
}

.sdvx-root.theme-dark .sdvx-tier-label {
  background: #000000 !important;
  color: #f4f4f5 !important;
}

.sdvx-root.theme-dark .sdvx-song-cell,
.sdvx-root.theme-dark .sdvx-search-summary span,
.sdvx-root.theme-dark .sdvx-weekly-card,
.sdvx-root.theme-dark .sdvx-weekly-tier {
  border-color: #3f3f46;
}

.sdvx-root.theme-dark .sdvx-search-summary span {
  background: #18181b;
}

.sdvx-root.theme-dark .sdvx-title-block h1,
.sdvx-root.theme-dark .sdvx-control,
.sdvx-root.theme-dark .sdvx-song-title,
.sdvx-root.theme-dark .sdvx-weekly-title h2,
.sdvx-root.theme-dark .sdvx-weekly-song-title {
  color: #f4f4f5;
}

.sdvx-root.theme-dark .sdvx-scope-summary {
  border-top-color: #27272a;
}

.sdvx-root.theme-dark .sdvx-scope-summary,
.sdvx-root.theme-dark .sdvx-search-summary,
.sdvx-root.theme-dark .sdvx-loading,
.sdvx-root.theme-dark .sdvx-empty,
.sdvx-root.theme-dark .sdvx-song-meta,
.sdvx-root.theme-dark .sdvx-difficulty,
.sdvx-root.theme-dark .sdvx-weekly-title p,
.sdvx-root.theme-dark .sdvx-weekly-count,
.sdvx-root.theme-dark .sdvx-weekly-meta,
.sdvx-root.theme-dark .sdvx-weekly-reason {
  color: #a1a1aa;
}

.sdvx-root.theme-dark .sdvx-weekly-tier {
  background: #27272a;
  color: #f4f4f5;
}

.sdvx-root.theme-dark .sdvx-data-status {
  color: #67e8f9;
}

.sdvx-root.theme-dark .sdvx-data-status.is-error {
  color: #fca5a5;
}

.sdvx-root.theme-dark .sdvx-song-detail {
  color: #67e8f9;
}

.sdvx-root.theme-dark .sdvx-spinner {
  border-color: #3f3f46;
  border-top-color: #f4f4f5;
}

.sdvx-root.theme-dark .sdvx-scroll {
  scrollbar-color: #71717a transparent;
}

.sdvx-root.theme-dark .sdvx-scroll::-webkit-scrollbar-thumb {
  background: #71717a;
}

@keyframes sdvx-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 980px) {
  .sdvx-controls {
    grid-template-columns: 1fr;
  }
  .sdvx-filter-row {
    grid-template-columns: 126px 90px 116px 132px minmax(0, 1fr) 58px;
  }
  .sdvx-song-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sdvx-weekly-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .sdvx-title-line {
    align-items: flex-start;
  }
  .sdvx-nav {
    flex-shrink: 1;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
}
@media (max-width: 640px) {
  .sdvx-wrap {
    padding: 0 6px;
  }
  .sdvx-title-block h1 {
    font-size: 15px;
  }
  .sdvx-controls {
    gap: 6px;
  }
  .sdvx-filter-row {
    grid-template-columns: 1fr 1fr;
  }
  .sdvx-sort-toggle,
  .sdvx-version-control,
  .sdvx-search,
  .sdvx-clear {
    grid-column: span 2;
  }
  .sdvx-scope-summary {
    flex-wrap: nowrap;
    gap: 6px;
    overflow-x: auto;
    padding-bottom: 1px;
    font-size: 9px;
    white-space: nowrap;
  }
  .sdvx-tier-row {
    grid-template-columns: 58px minmax(0, 1fr);
  }
  .sdvx-tier-label {
    padding: 4px 3px;
  }
  .sdvx-tier-name {
    font-size: 11px;
  }
  .sdvx-tier-count {
    display: none;
  }
  .sdvx-song-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sdvx-song-cell {
    min-height: 66px;
    padding: 4px;
  }
  .sdvx-title-wrap {
    align-items: flex-start;
  }
  .sdvx-song-title {
    display: -webkit-box;
    overflow: hidden;
    font-size: 11px;
    overflow-wrap: anywhere;
    text-overflow: clip;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .sdvx-youtube,
  .sdvx-song-source {
    width: 22px;
  }
  .sdvx-youtube svg {
    width: 12px;
    height: 12px;
  }
  .sdvx-song-source {
    right: 4px;
    bottom: 4px;
  }
  .sdvx-song-meta,
  .sdvx-song-detail {
    gap: 4px;
    padding-right: 24px;
    font-size: 9px;
  }
  .sdvx-weekly-grid {
    grid-template-columns: 1fr;
  }
  .sdvx-weekly-title p {
    white-space: normal;
  }
}
@media (max-width: 520px) {
  .sdvx-title-line {
    flex-wrap: wrap;
  }
  .sdvx-title-block,
  .sdvx-nav {
    width: 100%;
  }
  .sdvx-nav {
    justify-content: flex-start;
  }
  .sdvx-nav-action {
    padding: 0 7px;
  }
}
@media (max-width: 440px) {
  .sdvx-song-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`],
})
export class PageSdvxComponent implements OnInit {
    public loading: boolean = true;
    public themeMode: ThemeMode = 'dark';
    public allData: any = null;
    public songs: any[] = [];
    public levels: number[] = [];
    public difficulties: string[] = [];
    public versions: any[] = [];
    public selectedLevel: string = 'all';
    public selectedTiers: string[] = [];
    public selectedDifficulty: string = 'all';
    public selectedVersion: string = 'all';
    public searchText: string = '';
    public searchSummary: any = { query: '', total: 0, direct: 0, similar: 0 };
    public sortMode: SortMode = 'default';
    public sections: any[] = [];
    public stats: any = { total: 0, scope: 0, visible: 0 };
    public exportingChart: boolean = false;
    public titleTooltip: any = { visible: false, text: '', left: 0, top: 0, placement: 'above' };
    public dataRefreshing: boolean = false;
    public dataStatusMessage: string = '';
    public dataStatusError: boolean = false;
    public weeklyRecommendations: any[] = [];
    public weeklyKey: string = '';
    public weeklyRangeLabel: string = '';

    private tierOrder: string[] = [];
    private tierLabels: any = {};
    private readonly sortModeOrder: SortMode[] = ['default', 'chain', 'bpm', 'version', 'title'];
    private readonly similarSearchThreshold = 0.38;

    public tierPalette: any = {
        'S+': { accent: '#ef4444', weight: 0 },
        'S': { accent: '#f97316', weight: 1 },
        'A+': { accent: '#eab308', weight: 2 },
        'A': { accent: '#22c55e', weight: 3 },
        'B': { accent: '#06b6d4', weight: 4 },
        'C': { accent: '#6366f1', weight: 5 },
        '개인차': { accent: '#a855f7', weight: 6 },
        '미분류': { accent: '#a1a1aa', weight: 7 }
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.themeMode = this.loadThemeMode();
        this.applyThemeMode();
        await this.service.init();
        if (!this.isAllowedAccount()) {
            this.redirectUnauthorized();
            return;
        }
        await this.load();
    }

    public async load(force: boolean = false): Promise<boolean> {
        const initialLoad = !this.allData;
        if (initialLoad) this.loading = true;
        else this.dataRefreshing = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('tier_data', force ? { _ts: Date.now() } : {});
            if (code === 401 || code === 403) {
                this.redirectUnauthorized();
                throw new Error('sdvx access denied');
            }
            if (code !== 200 || !data) throw new Error('failed to load sdvx tier data');
            this.allData = data;
            this.tierOrder = Array.isArray(data.tierOrder) ? data.tierOrder : [];
            this.tierLabels = data.tierLabels || {};
            this.songs = Array.isArray(data.songs) ? data.songs.map((song: any, index: number) => this.normalizeSong(song, index)) : [];
            this.levels = this.normalizeLevels(data.levels, this.songs);
            this.difficulties = this.normalizeDifficulties(this.songs);
            this.versions = this.normalizeVersions(this.songs);
            if (initialLoad) this.selectedLevel = this.resolveInitialLevel();
            else if (this.selectedLevel !== 'all' && !this.levels.includes(Number(this.selectedLevel))) this.selectedLevel = 'all';
            this.refreshView();
            this.loading = false;
            this.dataRefreshing = false;
            await this.service.render();
            return true;
        } catch {
            if (initialLoad) {
                this.allData = null;
                this.songs = [];
                this.levels = [];
                this.difficulties = [];
                this.versions = [];
                this.sections = [];
                this.weeklyRecommendations = [];
                this.stats = { total: 0, scope: 0, visible: 0 };
            }
        }

        this.loading = false;
        this.dataRefreshing = false;
        await this.service.render();
        return false;
    }

    private isAllowedAccount(): boolean {
        const session = (this.service?.auth?.session || {}) as any;
        return String(session.id || '') === PRIVATE_ACCOUNT_ID;
    }

    private redirectUnauthorized() {
        const session = (this.service?.auth?.session || {}) as any;
        this.loading = false;
        this.dataRefreshing = false;
        this.service.href(session.id ? '/iidx' : '/auth');
    }

    public async refreshData() {
        if (this.loading || this.dataRefreshing) return;
        this.dataStatusError = false;
        this.dataStatusMessage = '최신 데이터 확인 중';
        await this.service.render();
        const loaded = await this.load(true);
        this.dataStatusError = !loaded;
        this.dataStatusMessage = loaded ? `가져오기 완료 · ${this.getDataUpdatedLabel()}` : '데이터를 가져오지 못했습니다';
        await this.service.render();
    }

    public getThemeToggleLabel(): string {
        return this.themeMode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환';
    }

    public async toggleThemeMode() {
        this.themeMode = this.themeMode === 'dark' ? 'light' : 'dark';
        try {
            localStorage.setItem(THEME_STORAGE_KEY, this.themeMode);
        } catch { }
        this.applyThemeMode();
        await this.service.render();
    }

    public onLevelChange() {
        const available = new Set(this.getTierTabs().map((tier) => tier.value));
        this.selectedTiers = this.selectedTiers.filter((tier) => available.has(tier));
        this.refreshView();
    }

    public selectTier(tier: string) {
        if (tier === 'all') {
            this.selectedTiers = [];
        } else {
            this.selectedTiers = this.selectedTiers.includes(tier)
                ? this.selectedTiers.filter((item) => item !== tier)
                : [...this.selectedTiers, tier];
        }
        this.refreshView();
    }

    public cycleSortMode() {
        const index = this.sortModeOrder.indexOf(this.sortMode);
        this.sortMode = this.sortModeOrder[(index + 1) % this.sortModeOrder.length];
        this.refreshView();
    }

    public clearFilters() {
        this.selectedLevel = 'all';
        this.selectedTiers = [];
        this.selectedDifficulty = 'all';
        this.selectedVersion = 'all';
        this.searchText = '';
        this.refreshView();
    }

    public hasActiveFilters(): boolean {
        return this.selectedLevel !== 'all'
            || this.selectedTiers.length > 0
            || this.selectedDifficulty !== 'all'
            || this.selectedVersion !== 'all'
            || !!this.searchText.trim();
    }

    public refreshView() {
        const selectedLevelNumber = Number(this.selectedLevel);
        const scopedSongs = this.selectedLevel === 'all'
            ? this.songs
            : this.songs.filter((song) => song.level === selectedLevelNumber);
        const query = this.normalizeSearch(this.searchText);
        const searchContext = query ? this.buildSearchContext(query) : null;
        const visible: any[] = [];
        let direct = 0;
        let similar = 0;

        for (const song of scopedSongs) {
            if (this.selectedTiers.length > 0 && !this.selectedTiers.includes(song.tier)) continue;
            if (this.selectedDifficulty !== 'all' && song.difficulty !== this.selectedDifficulty) continue;
            if (this.selectedVersion !== 'all' && song.version !== this.selectedVersion) continue;

            if (query) {
                const match = this.scoreSongSearch(song, query, searchContext);
                if (!match.matched) continue;
                if (match.direct) direct++;
                else similar++;
                visible.push({
                    ...song,
                    searchScore: match.score,
                    searchMatchKind: match.direct ? 'direct' : 'similar'
                });
                continue;
            }

            visible.push(song);
        }

        const sorted = this.sortSongs(visible);
        const grouped: any = {};
        for (const song of sorted) {
            const tier = song.tier || '미분류';
            if (!grouped[tier]) grouped[tier] = [];
            grouped[tier].push(song);
        }

        this.sections = Object.keys(grouped)
            .sort((a, b) => this.getTierOrder(a) - this.getTierOrder(b))
            .map((tier) => {
                const palette = this.getTierPalette(tier);
                return {
                    tier,
                    label: this.getTierLabel(tier),
                    songs: grouped[tier],
                    backgroundColor: palette.bg,
                    color: palette.fg,
                    accent: palette.accent
                };
            });

        this.searchSummary = {
            query: this.searchText.trim(),
            total: visible.length,
            direct,
            similar
        };
        this.stats = { total: this.songs.length, scope: scopedSongs.length, visible: visible.length };
        this.updateWeeklyRecommendations();
        this.service.render();
    }

    public getTierTabs() {
        const selectedLevelNumber = Number(this.selectedLevel);
        const seen: any = {};
        return this.songs
            .filter((song) => this.selectedLevel === 'all' || song.level === selectedLevelNumber)
            .map((song) => song.tier || '미분류')
            .filter((tier) => {
                if (seen[tier]) return false;
                seen[tier] = true;
                return true;
            })
            .sort((a, b) => this.getTierOrder(a) - this.getTierOrder(b))
            .map((tier) => ({
                value: tier,
                label: this.getTierLabel(tier),
                accent: this.getTierPalette(tier).accent
            }));
    }

    public isLevelSelected(level: number): boolean {
        return String(level) === String(this.selectedLevel);
    }

    public isAllLevelsSelected(): boolean {
        return this.selectedLevel === 'all';
    }

    public isTierSelected(tier: string): boolean {
        return tier === 'all' ? this.selectedTiers.length === 0 : this.selectedTiers.includes(tier);
    }

    public getLevelCount(level: number): number {
        const meta = this.getLevelMeta(level);
        if (meta && Number(meta.songCount)) return Number(meta.songCount);
        return this.songs.filter((song) => song.level === Number(level)).length;
    }

    public getSourceUrl(): string {
        if (this.selectedLevel === 'all') return this.allData?.sourceBaseUrl || 'https://w.atwiki.jp/sdvx/pages/9057.html';
        const meta = this.getLevelMeta(Number(this.selectedLevel));
        return meta?.sourceUrl || this.allData?.sourceBaseUrl || 'https://w.atwiki.jp/sdvx/pages/9057.html';
    }

    public getSourceLabel(): string {
        if (this.selectedLevel === 'all') return '서열표 원본';
        return `Lv${this.selectedLevel} 원본`;
    }

    public getScopeLabel(): string {
        return this.selectedLevel === 'all' ? '전체 레벨' : `Lv${this.selectedLevel}`;
    }

    public getDataUpdatedLabel(): string {
        const raw = String(this.allData && this.allData.generatedAt || '').trim();
        if (!raw) return '갱신일 미상';
        const date = new Date(raw.length <= 10 ? `${raw}T00:00:00Z` : raw);
        if (Number.isNaN(date.getTime())) return raw;
        return `원본 ${date.toLocaleDateString('ko-KR', { timeZone: 'UTC' })}`;
    }

    public getDataRefreshTitle(): string {
        return `${this.getDataUpdatedLabel()} · 배포된 최신 데이터를 다시 가져옵니다`;
    }

    private getWeeklyInfo() {
        const now = new Date();
        const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
        const day = date.getUTCDay() || 7;
        const monday = new Date(date);
        monday.setUTCDate(date.getUTCDate() - day + 1);
        const sunday = new Date(monday);
        sunday.setUTCDate(monday.getUTCDate() + 6);

        const thursday = new Date(date);
        thursday.setUTCDate(date.getUTCDate() + 4 - day);
        const year = thursday.getUTCFullYear();
        const yearStart = new Date(Date.UTC(year, 0, 1));
        const week = Math.ceil((((thursday.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        const short = (value: Date) => `${String(value.getUTCMonth() + 1).padStart(2, '0')}.${String(value.getUTCDate()).padStart(2, '0')}`;
        return {
            key: `${year}-W${String(week).padStart(2, '0')}`,
            label: `${short(monday)}–${short(sunday)}`
        };
    }

    private hashString(value: string): number {
        let hash = 2166136261;
        for (let index = 0; index < value.length; index++) {
            hash ^= value.charCodeAt(index);
            hash = Math.imul(hash, 16777619);
        }
        return hash >>> 0;
    }

    private seededUnit(value: string): number {
        return this.hashString(value) / 4294967295;
    }

    private getWeeklyPool(): any[] {
        return this.songs.filter((song) => {
            if (this.selectedLevel !== 'all' && song.level !== Number(this.selectedLevel)) return false;
            if (this.selectedTiers.length > 0 && !this.selectedTiers.includes(song.tier)) return false;
            if (this.selectedDifficulty !== 'all' && song.difficulty !== this.selectedDifficulty) return false;
            if (this.selectedVersion !== 'all' && song.version !== this.selectedVersion) return false;
            return true;
        });
    }

    private selectWeeklyDiverse(candidates: any[]): any[] {
        const selected: any[] = [];
        const selectedIds: any = {};
        const tierCounts: any = {};
        const versionCounts: any = {};
        const limits = [[2, 2], [3, 3], [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]];

        for (const [tierLimit, versionLimit] of limits) {
            for (const song of candidates) {
                if (selected.length >= 6) break;
                if (selectedIds[song.id]) continue;
                if ((tierCounts[song.tier] || 0) >= tierLimit) continue;
                if ((versionCounts[song.version] || 0) >= versionLimit) continue;
                selected.push(song);
                selectedIds[song.id] = true;
                tierCounts[song.tier] = (tierCounts[song.tier] || 0) + 1;
                versionCounts[song.version] = (versionCounts[song.version] || 0) + 1;
            }
            if (selected.length >= 6) break;
        }
        return selected;
    }

    private updateWeeklyRecommendations() {
        const info = this.getWeeklyInfo();
        this.weeklyKey = info.key;
        this.weeklyRangeLabel = info.label;
        const pool = this.getWeeklyPool();
        if (!pool.length) {
            this.weeklyRecommendations = [];
            return;
        }

        const scores = pool.map((song) => Number(song.difficultyScore)).filter((score) => Number.isFinite(score));
        const minScore = scores.length ? Math.min(...scores) : 0;
        const maxScore = scores.length ? Math.max(...scores) : 1;
        const tierMax = Math.max(this.tierOrder.length - 1, 1);
        const scope = `${this.selectedLevel}:${this.selectedDifficulty}:${this.selectedVersion}:${this.selectedTiers.join(',')}`;
        const candidates = pool.map((song) => {
            const rawScore = Number(song.difficultyScore);
            const scoreWeight = Number.isFinite(rawScore) && maxScore > minScore ? (rawScore - minScore) / (maxScore - minScore) : 0.5;
            const tierWeight = 1 - Math.min(this.getTierOrder(song.tier), tierMax) / tierMax;
            const rotation = this.seededUnit(`${info.key}:sdvx:${scope}:${song.id}`);
            return { ...song, weeklyScore: rotation * 0.68 + scoreWeight * 0.22 + tierWeight * 0.10 };
        }).sort((left, right) => right.weeklyScore - left.weeklyScore || this.compareText(left.title, right.title));

        this.weeklyRecommendations = this.selectWeeklyDiverse(candidates);
    }

    public getWeeklyTierLabel(song: any): string {
        return this.getTierLabel(song && song.tier);
    }

    public getWeeklyReason(song: any): string {
        const tier = this.getWeeklyTierLabel(song);
        const attribute = String(song && song.attribute || '').trim();
        if (attribute) return `${tier} · ${attribute}`;
        if (Number(song && song.chainValue || 0) >= 3000) return `${tier} · 고밀도 CHAIN ${song.chainValue} 도전곡`;
        return `${tier} · ${song.difficulty || '채보'} 주간 도전곡`;
    }

    public getSortModeLabel(): string {
        if (this.sortMode === 'chain') return '정렬: CHAIN순';
        if (this.sortMode === 'bpm') return '정렬: BPM순';
        if (this.sortMode === 'version') return '정렬: 버전순';
        if (this.sortMode === 'title') return '정렬: 곡명순';
        return '정렬: 기본';
    }

    public getSortToggleAriaLabel(): string {
        const index = this.sortModeOrder.indexOf(this.sortMode);
        const next = this.sortModeOrder[(index + 1) % this.sortModeOrder.length];
        const labels: any = { default: '기본', chain: 'CHAIN순', bpm: 'BPM순', version: '버전순', title: '곡명순' };
        return `정렬 변경: 다음은 ${labels[next]}`;
    }

    public getDifficultyLabel(value: string): string {
        return value || '채보';
    }

    public getTierAccent(tier: string): string {
        return this.getTierPalette(tier).accent;
    }

    public getSongTitleTooltip(song: any): string {
        const detail = String(song.attribute || song.artist || '').trim();
        return detail ? `${song.title} · ${detail}` : song.title;
    }

    public hasSearchQuery(): boolean {
        return !!this.normalizeSearch(this.searchText);
    }

    public onSearchInput() {
        this.refreshView();
    }

    public onSearchKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape' || !this.searchText) return;
        event.preventDefault();
        this.searchText = '';
        this.refreshView();
    }

    public showTitleTooltip(song: any, event: any) {
        const text = this.getSongTitleTooltip(song);
        if (!text || !event || !event.currentTarget) return;

        const rect = event.currentTarget.getBoundingClientRect();
        const maxWidth = Math.min(420, Math.max(180, window.innerWidth - 16));
        const minLeft = (maxWidth / 2) + 8;
        const maxLeft = window.innerWidth - minLeft;
        const center = rect.left + rect.width / 2;
        const placement = rect.top < 64 ? 'below' : 'above';
        this.titleTooltip = {
            visible: true,
            text,
            left: Math.min(Math.max(center, minLeft), maxLeft),
            top: placement === 'below' ? rect.bottom + 8 : rect.top - 8,
            placement
        };
        this.service.render();
    }

    public hideTitleTooltip() {
        if (!this.titleTooltip.visible) return;
        this.titleTooltip = { visible: false, text: '', left: 0, top: 0, placement: 'above' };
        this.service.render();
    }

    public getYoutubeQuery(song: any): string {
        return String(song && (song.youtubeQuery || `SOUND VOLTEX ${song.title} ${song.difficulty || ''}`) || '').trim();
    }

    public getYoutubeUrl(song: any): string {
        const query = this.getYoutubeQuery(song);
        return query ? `${YOUTUBE_SEARCH_URL}?search_query=${encodeURIComponent(query)}` : '';
    }

    public isYoutubeReady(song: any): boolean {
        return !!this.getYoutubeUrl(song);
    }

    public getSongSourceUrl(song: any): string {
        const url = String(song && song.sourceUrl || '').trim();
        return /^https:\/\//.test(url) ? url : '';
    }

    public isSongSourceReady(song: any): boolean {
        return !!this.getSongSourceUrl(song);
    }

    private compactSearch(value: any): string {
        return this.normalizeSearch(value).replace(/\s+/g, '');
    }

    private uniqueSearchStrings(values: any[]): string[] {
        const seen: any = {};
        const output: string[] = [];
        for (const value of values) {
            const text = String(value || '').trim();
            if (!text || seen[text]) continue;
            seen[text] = true;
            output.push(text);
        }
        return output;
    }

    private getExpandedSearchTerms(query: string): string[] {
        const baseTerms = query.split(/\s+/).filter((term) => !!term);
        const aliases: string[][] = [
            ['맥시멈', 'maximum', 'mxm'],
            ['인피니트', 'infinite', 'inf'],
            ['그래비티', 'gravity', 'grv'],
            ['헤븐리', 'heavenly', 'hvn'],
            ['비비드', 'vivid', 'vvd'],
            ['익시드', 'exceed', 'xcd'],
            ['익저스트', 'exhaust', 'exh'],
            ['체인', 'chain', '노트'],
            ['변속', '소프란', 'soflan', 'bpm', '속도변화'],
            ['개인차', 'individual'],
            ['사볼', '볼텍', 'sdvx', 'sound voltex']
        ].map((group) => group.map((term) => this.normalizeSearch(term)).filter((term) => !!term));

        const expanded = [...baseTerms];
        for (const term of baseTerms) {
            for (const group of aliases) {
                if (!group.some((alias) => alias === term || (term.length >= 3 && alias.length >= 3 && (alias.includes(term) || term.includes(alias))))) continue;
                expanded.push(...group);
            }
        }
        return this.uniqueSearchStrings(expanded);
    }

    private getSongSearchFields(song: any): string[] {
        return this.uniqueSearchStrings([
            song && song.title,
            song && song.artist,
            song && song.attribute,
            song && song.id,
            song && song.difficulty,
            this.getDifficultyLabel(song && song.difficulty),
            song && song.level ? `level ${song.level}` : '',
            song && song.level ? `${song.level}레벨` : '',
            song && song.level ? `lv${song.level}` : '',
            song && song.version,
            song && song.versionLabel,
            song && song.tier,
            song && song.tierLabel,
            song && song.bpm ? `${song.bpm} bpm` : '',
            song && song.chainValue ? `${song.chainValue} chain` : '',
            song && song.chainValue ? `${song.chainValue} 체인` : ''
        ]);
    }

    private getCharacterNgrams(value: string, size: number = 2): string[] {
        const compact = this.compactSearch(value);
        if (!compact) return [];
        if (compact.length <= size) return [compact];
        const grams: string[] = [];
        for (let index = 0; index <= compact.length - size; index++) grams.push(compact.slice(index, index + size));
        return grams;
    }

    private diceSimilarity(left: string, right: string): number {
        const leftGrams = this.getCharacterNgrams(left);
        const rightGrams = this.getCharacterNgrams(right);
        if (!leftGrams.length || !rightGrams.length) return 0;

        const counts: any = {};
        for (const gram of leftGrams) counts[gram] = (counts[gram] || 0) + 1;
        let overlap = 0;
        for (const gram of rightGrams) {
            if (!counts[gram]) continue;
            counts[gram]--;
            overlap++;
        }
        return (2 * overlap) / (leftGrams.length + rightGrams.length);
    }

    private levenshteinSimilarity(left: string, right: string): number {
        const a = this.compactSearch(left);
        const b = this.compactSearch(right);
        if (!a || !b) return 0;
        if (a === b) return 1;
        const maxLength = Math.max(a.length, b.length);
        const previous: number[] = [];
        const current: number[] = [];
        for (let index = 0; index <= b.length; index++) previous[index] = index;
        for (let i = 1; i <= a.length; i++) {
            current[0] = i;
            for (let j = 1; j <= b.length; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                current[j] = Math.min(current[j - 1] + 1, previous[j] + 1, previous[j - 1] + cost);
            }
            for (let j = 0; j <= b.length; j++) previous[j] = current[j];
        }
        return 1 - previous[b.length] / maxLength;
    }

    private tokenSimilarity(queryTerms: string[], field: string): number {
        const fieldText = this.normalizeSearch(field);
        if (!fieldText || !queryTerms.length) return 0;
        let hits = 0;
        for (const term of queryTerms) {
            if (fieldText.includes(term) || this.diceSimilarity(term, fieldText) >= 0.72) hits++;
        }
        return hits / queryTerms.length;
    }

    private buildSearchContext(query: string) {
        const compactQuery = this.compactSearch(query);
        return {
            compactQuery,
            shortQuery: compactQuery.length <= 2,
            baseTerms: query.split(/\s+/).filter((term) => !!term),
            terms: this.getExpandedSearchTerms(query)
        };
    }

    private getSongSearchIndex(song: any) {
        if (Array.isArray(song && song.__sdvxSearchIndex)) return song.__sdvxSearchIndex;
        const index = this.getSongSearchFields(song).map((field) => ({
            raw: field,
            text: this.normalizeSearch(field),
            compact: this.compactSearch(field)
        }));
        try {
            Object.defineProperty(song, '__sdvxSearchIndex', { value: index, configurable: true });
        } catch {
            song.__sdvxSearchIndex = index;
        }
        return index;
    }

    private scoreSongSearch(song: any, query: string, context: any = null) {
        const searchContext = context || this.buildSearchContext(query);
        const compactQuery = searchContext.compactQuery;
        if (!query || !compactQuery) return { matched: true, direct: true, score: 1 };

        const normalizedFields = this.getSongSearchIndex(song);
        const shortQuery = searchContext.shortQuery;
        const baseTerms = searchContext.baseTerms;
        const terms = searchContext.terms;
        let bestScore = 0;
        let direct = false;
        let semanticAlias = false;

        for (const field of normalizedFields) {
            if (field.text === query || field.compact === compactQuery) {
                bestScore = Math.max(bestScore, 1);
                direct = true;
                continue;
            }
            if (!shortQuery && (field.text.includes(query) || field.compact.includes(compactQuery))) {
                const ratio = Math.min(compactQuery.length, field.compact.length) / Math.max(compactQuery.length, field.compact.length);
                bestScore = Math.max(bestScore, 0.82 + ratio * 0.12);
                direct = true;
            }
            if (baseTerms.length > 1 && baseTerms.every((term) => field.text.includes(term) || field.compact.includes(this.compactSearch(term)))) {
                bestScore = Math.max(bestScore, 0.88);
                direct = true;
            }
            if (baseTerms.length === 1 && terms.some((term) => {
                const compactTerm = this.compactSearch(term);
                return term.length > 1 && compactTerm !== compactQuery && (field.text.includes(term) || field.compact.includes(compactTerm));
            })) {
                bestScore = Math.max(bestScore, 0.76);
                if (!direct) semanticAlias = true;
            }
        }

        if (baseTerms.length > 1 && baseTerms.every((term: string) => normalizedFields.some((field: any) => {
            const compactTerm = this.compactSearch(term);
            return field.text.includes(term) || field.compact.includes(compactTerm);
        }))) {
            bestScore = Math.max(bestScore, 0.88);
            direct = true;
        }

        if (direct) return { matched: true, direct: true, score: bestScore };
        if (semanticAlias) return { matched: true, direct: false, score: bestScore };
        if (shortQuery) return { matched: false, direct: false, score: bestScore };

        const titles = normalizedFields.slice(0, 2).map((field: any) => field.raw);
        for (const title of titles) {
            bestScore = Math.max(
                bestScore,
                this.diceSimilarity(query, title) * 0.82,
                this.levenshteinSimilarity(query, title) * 0.74,
                this.tokenSimilarity(terms, title) * 0.86
            );
        }
        return {
            matched: bestScore >= this.similarSearchThreshold,
            direct: false,
            score: bestScore
        };
    }

    public trackLevel(index: number, level: number) {
        return level;
    }

    public trackTier(index: number, tab: any) {
        return tab.value;
    }

    public trackSection(index: number, section: any) {
        return section.tier;
    }

    public trackSong(index: number, song: any) {
        return song.id || index;
    }

    private redirectYoutubeWindow(youtubeWindow: Window, url: string) {
        try {
            if (!youtubeWindow.closed) youtubeWindow.location.replace(url);
        } catch {
            try {
                youtubeWindow.location.href = url;
            } catch { }
        }
    }

    public async openYoutube(song: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const query = this.getYoutubeQuery(song);
        const fallbackUrl = this.getYoutubeUrl(song);
        if (!query || !fallbackUrl) return;

        const youtubeWindow = window.open('about:blank', '_blank');
        if (!youtubeWindow) {
            window.open(fallbackUrl, '_blank', 'noopener');
            return;
        }

        try {
            youtubeWindow.document.title = 'YouTube';
            if (youtubeWindow.document.body) youtubeWindow.document.body.textContent = 'YouTube로 이동 중...';
        } catch { }

        try {
            const { code, data } = await wiz.call('youtube_search', { query });
            this.redirectYoutubeWindow(youtubeWindow, code === 200 && data && data.url ? data.url : fallbackUrl);
        } catch {
            this.redirectYoutubeWindow(youtubeWindow, fallbackUrl);
        }
    }

    public openSongSource(song: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const url = this.getSongSourceUrl(song);
        if (url) window.open(url, '_blank', 'noopener');
    }

    private async canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
        return await new Promise<Blob>((resolve, reject) => {
            if (canvas.toBlob) {
                canvas.toBlob((blob) => {
                    if (blob && blob.size > 0) {
                        resolve(blob);
                    } else {
                        reject(new Error('PNG 생성 실패'));
                    }
                }, 'image/png');
                return;
            }

            const dataUrl = canvas.toDataURL('image/png');
            if (!dataUrl || dataUrl === 'data:,') {
                reject(new Error('PNG 생성 실패'));
                return;
            }

            const parts = dataUrl.split(',');
            const binary = atob(parts[1]);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            resolve(new Blob([bytes], { type: 'image/png' }));
        });
    }

    private async downloadCanvasAsPng(canvas: HTMLCanvasElement, filename: string) {
        const blob = await this.canvasToPngBlob(canvas);
        const nav = window.navigator as any;
        if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, filename);
            return;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.rel = 'noopener';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    private drawExportText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxW: number) {
        let value = String(text || '');
        if (ctx.measureText(value).width <= maxW) {
            ctx.fillText(value, x, y);
            return;
        }
        while (value.length > 0 && ctx.measureText(value + '...').width > maxW) {
            value = value.slice(0, -1);
        }
        ctx.fillText(value + '...', x, y);
    }

    private fillExportRoundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, fill: string) {
        const radius = Math.min(r, w / 2, h / 2);
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + w - radius, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
        ctx.lineTo(x + w, y + h - radius);
        ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
        ctx.lineTo(x + radius, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fillStyle = fill;
        ctx.fill();
    }

    public async exportChart() {
        if (this.exportingChart) return;
        this.exportingChart = true;
        await this.service.render();

        try {
            await ((document as any).fonts?.ready || Promise.resolve());
            const dark = this.themeMode === 'dark';
            const CW = 1440;
            const margin = 40;
            const labelW = 132;
            const rowGap = 6;
            const cols = 6;
            const cardGap = 0;
            const contentW = CW - (margin * 2);
            const gridW = contentW - labelW - rowGap;
            const cardW = Math.floor((gridW - (cardGap * (cols - 1))) / cols);
            const cardH = 62;
            const headerH = 144;
            const footerH = 54;
            const sectionGap = 7;
            const fontFamily = 'SUIT, "Noto Sans KR", "Noto Sans JP", Arial, sans-serif';
            const visibleSections = (this.sections || []).filter((section: any) => section && Array.isArray(section.songs));

            let totalH = headerH + footerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                totalH += Math.max(62, rows * cardH + (rows - 1) * cardGap) + sectionGap;
            }

            const maxCanvasSide = 16000;
            const maxCanvasArea = 16000000;
            const exportScale = Math.min(
                1,
                maxCanvasSide / Math.max(CW, totalH),
                Math.sqrt(maxCanvasArea / (CW * totalH))
            );

            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.floor(CW * exportScale));
            canvas.height = Math.max(1, Math.floor(totalH * exportScale));
            const ctx = canvas.getContext('2d');
            if (!ctx) throw new Error('Canvas 생성 실패');
            ctx.scale(exportScale, exportScale);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            const bg = dark ? '#09090b' : '#f4f4f5';
            const panel = dark ? '#18181b' : '#ffffff';
            const border = dark ? '#52525b' : '#a1a1aa';
            const cellBorder = dark ? '#3f3f46' : '#d4d4d8';
            const text = dark ? '#f4f4f5' : '#18181b';
            const muted = dark ? '#a1a1aa' : '#71717a';
            const scopeLabel = this.getScopeLabel();

            ctx.fillStyle = bg;
            ctx.fillRect(0, 0, CW, totalH);
            this.fillExportRoundRect(ctx, margin, 24, contentW, 96, 4, panel);
            ctx.strokeStyle = border;
            ctx.strokeRect(margin + 0.5, 24.5, contentW - 1, 95);
            ctx.fillStyle = text;
            ctx.font = `800 30px ${fontFamily}`;
            ctx.fillText(`SOUND VOLTEX 서열표 ${scopeLabel}`, margin + 24, 65);
            ctx.fillStyle = muted;
            ctx.font = `600 15px ${fontFamily}`;
            ctx.fillText(`선택 ${this.stats.scope}곡 · 표시 ${this.stats.visible}곡 · ${this.getSortModeLabel()}`, margin + 24, 92);

            let y = headerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                const sectionH = Math.max(62, rows * cardH + (rows - 1) * cardGap);
                const labelFill = dark ? '#000000' : (section.backgroundColor || '#ffffff');
                const labelText = dark ? '#f4f4f5' : (section.color || '#27272a');

                this.fillExportRoundRect(ctx, margin, y, labelW, sectionH, 0, labelFill);
                ctx.strokeStyle = border;
                ctx.strokeRect(margin + 0.5, y + 0.5, labelW - 1, sectionH - 1);
                ctx.fillStyle = labelText;
                ctx.font = `800 16px ${fontFamily}`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(String(section.label || section.tier || '미분류'), margin + labelW / 2, y + sectionH / 2 - 8);
                ctx.font = `700 12px ${fontFamily}`;
                ctx.fillText(`${section.songs.length}곡`, margin + labelW / 2, y + sectionH / 2 + 14);
                ctx.textAlign = 'left';
                ctx.textBaseline = 'alphabetic';

                section.songs.forEach((song: any, index: number) => {
                    const col = index % cols;
                    const row = Math.floor(index / cols);
                    const x = margin + labelW + rowGap + col * (cardW + cardGap);
                    const cy = y + row * (cardH + cardGap);
                    ctx.fillStyle = panel;
                    ctx.fillRect(x, cy, cardW, cardH);
                    ctx.strokeStyle = cellBorder;
                    ctx.strokeRect(x + 0.5, cy + 0.5, cardW - 1, cardH - 1);

                    ctx.font = `700 11px ${fontFamily}`;
                    ctx.fillStyle = muted;
                    ctx.fillText(this.getDifficultyLabel(song.difficulty), x + 14, cy + 20);

                    ctx.font = `800 13px ${fontFamily}`;
                    ctx.fillStyle = text;
                    this.drawExportText(ctx, song.title, x + 46, cy + 20, cardW - 58);

                    ctx.font = `600 11px ${fontFamily}`;
                    ctx.fillStyle = muted;
                    const meta = `Lv${song.level} · ${song.versionLabel || ''}`;
                    this.drawExportText(ctx, meta, x + 14, cy + 39, cardW - 28);

                    ctx.font = `500 9px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace`;
                    const detail = `CHAIN ${song.chainValue || song.chain || 0} · ${song.bpm || ''} BPM`;
                    this.drawExportText(ctx, detail, x + 14, cy + 55, cardW - 28);
                });

                y += sectionH + sectionGap;
            }

            ctx.fillStyle = muted;
            ctx.font = `500 13px ${fontFamily}`;
            ctx.textAlign = 'center';
            ctx.fillText(`서열표 데이터 출처: ${this.getSourceLabel()}`, CW / 2, totalH - 28);

            const d = new Date();
            const ds = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
            await this.downloadCanvasAsPng(canvas, `sdvx서열표_${scopeLabel.replace(/\s+/g, '')}_${ds}.png`);
        } catch (e) {
            console.error('Export failed:', e);
            const msg = e instanceof Error ? e.message : String(e);
            alert('이미지 저장 실패: ' + msg);
        } finally {
            this.exportingChart = false;
            await this.service.render();
        }
    }

    private normalizeSong(song: any, index: number) {
        const tier = song.tier || '미분류';
        const version = song.version || song.versionLabel || 'unknown';
        return {
            ...song,
            id: song.id || `sdvx-${index}`,
            level: Number(song.level || 0),
            tier,
            tierLabel: song.tierLabel || this.getTierLabel(tier),
            difficulty: song.difficulty || 'MXM',
            version,
            versionLabel: song.versionLabel || version,
            bpmValue: Number(song.bpmValue || this.extractBpmValue(song.bpm)),
            chainValue: Number(song.chainValue || song.chain || 0)
        };
    }

    private normalizeLevels(levels: any[], songs: any[]): number[] {
        const values = Array.isArray(levels) && levels.length
            ? levels.map((item: any) => Number(item.level || item))
            : songs.map((song: any) => Number(song.level));
        return values
            .filter((level: number, index: number, list: number[]) => Number.isFinite(level) && list.indexOf(level) === index)
            .sort((a: number, b: number) => b - a);
    }

    private normalizeDifficulties(songs: any[]): string[] {
        const order = ['MXM', 'INF', 'GRV', 'HVN', 'VVD', 'XCD', 'ULT', 'EXH'];
        return order.filter((difficulty) => songs.some((song) => song.difficulty === difficulty));
    }

    private normalizeVersions(songs: any[]) {
        const seen: any = {};
        return songs
            .filter((song) => {
                if (!song.version || seen[song.version]) return false;
                seen[song.version] = true;
                return true;
            })
            .map((song) => ({ value: song.version, label: song.versionLabel || song.version }))
            .sort((a, b) => this.compareText(a.label, b.label));
    }

    private resolveInitialLevel(): string {
        const routeValue = String((window as any).WizRoute?.segment?.level || '').toLowerCase();
        if (routeValue === 'all') return 'all';
        const routeLevel = Number((window as any).WizRoute?.segment?.level);
        if (Number.isFinite(routeLevel) && this.levels.includes(routeLevel)) return String(routeLevel);
        return 'all';
    }

    private getLevelMeta(level: number) {
        const levels = Array.isArray(this.allData?.levels) ? this.allData.levels : [];
        return levels.find((item: any) => Number(item.level) === Number(level));
    }

    private sortSongs(songs: any[]): any[] {
        return [...songs].sort((a, b) => {
            if (this.hasSearchQuery()) {
                const searchDiff = Number(b.searchScore || 0) - Number(a.searchScore || 0);
                if (Math.abs(searchDiff) > 0.0001) return searchDiff;
            }
            if (this.sortMode === 'chain') {
                return (Number(b.chainValue) || 0) - (Number(a.chainValue) || 0) || this.compareTierThenTitle(a, b);
            }
            if (this.sortMode === 'bpm') {
                return (Number(b.bpmValue) || 0) - (Number(a.bpmValue) || 0) || this.compareTierThenTitle(a, b);
            }
            if (this.sortMode === 'version') {
                return this.compareText(a.versionLabel, b.versionLabel) || this.compareTierThenTitle(a, b);
            }
            if (this.sortMode === 'title') {
                return this.compareText(a.title, b.title);
            }
            return this.compareTierThenTitle(a, b);
        });
    }

    private compareTierThenTitle(a: any, b: any): number {
        const tierDiff = this.getTierOrder(a.tier) - this.getTierOrder(b.tier);
        if (tierDiff !== 0) return tierDiff;
        const scoreDiff = (Number(b.difficultyScore) || 0) - (Number(a.difficultyScore) || 0);
        if (scoreDiff !== 0) return scoreDiff;
        return this.compareText(a.title, b.title);
    }

    private compareText(a: any, b: any): number {
        return String(a || '').localeCompare(String(b || ''), 'ko');
    }

    private getTierLabel(tier: string): string {
        return this.tierLabels[tier] || this.tierPalette[tier]?.label || tier || '미분류';
    }

    private getTierOrder(tier: string): number {
        const index = this.tierOrder.indexOf(tier);
        return index >= 0 ? index : 999;
    }

    private getTierPalette(tier: string) {
        const item = this.tierPalette[tier] || this.tierPalette['미분류'];
        const lightBg = ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#f7f7f8', '#f4f4f5', '#f4f4f5'];
        const index = Math.min(Number(item.weight || 0), lightBg.length - 1);
        return {
            bg: lightBg[index],
            fg: '#27272a',
            accent: item.accent || '#a1a1aa'
        };
    }

    private normalizeSearch(value: any): string {
        return String(value || '')
            .normalize('NFKC')
            .toLowerCase()
            .replace(/[_\-~〜～–—－/]+/g, ' ')
            .replace(/[\p{P}\p{S}]+/gu, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    private extractBpmValue(value: any): number {
        const matches = String(value || '').match(/\d+(?:\.\d+)?/g);
        if (!matches || !matches.length) return 0;
        return Math.max(...matches.map((item) => Number(item)).filter((item) => Number.isFinite(item)));
    }

    private loadThemeMode(): ThemeMode {
        try {
            const saved = localStorage.getItem(THEME_STORAGE_KEY);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch { }
        return 'dark';
    }

    private applyThemeMode() {
        try {
            document.documentElement.setAttribute('data-taigo-theme', this.themeMode);
            document.documentElement.style.colorScheme = this.themeMode;
        } catch { }
    }
}

export default PageSdvxComponent;